export default __webpack_public_path__ + "static/media/RemoveImgIcon.92f483ac.svg";